// @flow
/** @jsx jsx */

import Text from '../Text';
import { marginToCss } from '@zapier/common-utils';
import { type ColorName, Colors } from '@zapier/theme';
import { css, jsx } from '@emotion/core';

import type { Spacing } from '@zapier/common-utils';

const badgeBaseCss = css({
  alignItems: 'center',
  borderRadius: 50,
  borderStyle: 'solid',
  borderWidth: 1,
  display: 'inline-flex',
  justifyContent: 'center',
  minHeight: 22,
  overflow: 'hidden',
  padding: '0 5px',
  textAlign: 'center',
});

const blockCss = css({
  boxSizing: 'border-box',
  display: 'flex',
  width: '100%',
});

type Props = {
  /** True if the badge should render as a block element. */
  block: boolean,
  /** The color of text and border to render. Renders an 'adamantium' border with 'steel' text color by default. */
  color?: ColorName,
  margin?: Spacing,
  /** Text to be rendered. */
  text: string | number,
};

/**
 * Renders a small badge.
 */
const Badge = (props: Props) => {
  const color = props.color ? props.color : 'steel';

  const borderColor = props.color ? Colors[props.color] : Colors.adamantium;

  const badgeCss = css(
    badgeBaseCss,
    marginToCss(props.margin),
    props.block && blockCss,
    {
      borderColor,
    }
  );

  return (
    <div css={badgeCss}>
      <Text color={color} type="fine">
        <strong>{props.text}</strong>
      </Text>
    </div>
  );
};

Badge.defaultProps = {
  block: false,
  color: undefined,
};

export default Badge;
